import slugify from 'slugify';

import { Hcp } from '@/core/graphql/generated/types';

type Props = {
	firstName: Hcp['firstNameCda_V'];
	lastName: Hcp['lastNameCda_V'];
	id: Hcp['vid_V'];
	tab?: string;
};

export const hcpUrl = ({
	firstName,
	lastName,
	id,
	tab = ''
}: Props): string => {
	if (!firstName || !lastName || !id) {
		return '';
	}

	const trimmedFirstName = firstName.trim();
	const trimmedLastName = lastName.trim();
	const trimmedId = id.trim();
	const trimmedTab = tab.trim();

	const baseSlug = slugify(`${trimmedFirstName}-${trimmedLastName}`, {
		replacement: '-', // Default to dash replacement
		lower: false, // Ensure slug is not in lowercase as IDs are case-sensitive
		strict: false, // Preserve non-ASCII letters (e.g. Hangul, CJK)
		remove: /[^\p{L}\p{N}\s-]/gu // Strip punctuation/symbols, keep any-script letters/digits
	});

	return trimmedTab
		? `${baseSlug}-${trimmedId}/${trimmedTab}`
		: `${baseSlug}-${trimmedId}`;
};
